import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import DashboardLayout from "./layouts/DashboardLayout";
import Perfiles from "./features/perfiles/pages/Perfiles";
import { getToken } from "./services/authService";
import Cacerias from "./features/cacerias/pages/cacerias";
import Armas from "./features/armas/pages/Armas";
import Habitaciones from "./features/habitaciones/pages/Habitaciones";
import Vinos from "./features/vinos/pages/Vinos";
import Calendario from "./features/calendario/pages/Calendario";
import Evento from "./features/eventos/pages/Evento";
import Platos from "./features/platos/pages/Platos";
import MenusPorEvento from "./features/menus/pages/MenuPorEvento";
import Notificaciones from "./features/notificaciones/pages/Notificaciones";
import AlertasTitulares from "./features/notificaciones/pages/AlertasTitulares";
import Alergenos from "./features/alergenos/pages/Alergenos";
import PrintMenuPage from "./components/PrintMenuPage";
import PrintVinosPage from "./components/PrintVinosPage";
import PrintHabitacionesPage from "./components/PrintHabitacionesPage";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import EventoDetalle from "./features/eventos/pages/EventoDetalle";

function App() {
  const isLoggedIn = !!getToken();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginForm onLogin={() => window.location.href = "/"} />} />

        {isLoggedIn ? (
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Calendario />} />
            <Route path="/perfiles" element={<Perfiles />} />
            <Route path="/perfiles/:id" element={<Perfiles />} />
            <Route path="/cacerias" element={<Cacerias />} />
            <Route path="/cacerias/:id" element={<Cacerias />} />
            <Route path="/armas" element={<Armas />} />
            <Route path="/habitaciones" element={<Habitaciones />} />
            <Route path="/platos" element={<Platos />} />
            <Route path="/vinos" element={<Vinos />} />
            <Route path="/eventos" element={<Evento />} />
            <Route path="/menus" element={<MenusPorEvento />} />
            <Route path="/notificaciones" element={<Notificaciones />} />
            <Route path="/alertas-titulares" element={<AlertasTitulares />} />
            <Route path="/alergenos" element={<Alergenos />} />
            <Route path="/print/menu" element={<PrintMenuPage />} />
            <Route path="/print/vinos" element={<PrintVinosPage />} />
            <Route path="/print/habitaciones" element={<PrintHabitacionesPage />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/eventos/:id" element={<EventoDetalle />} />

          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
